export default __webpack_public_path__ + "assets/images/a74fe70d64c13ee5b9515282c3ceedac.svg";